import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom";
import MainPage from "./pages/MainPage";
import ManualPage from "./pages/ManualPage/ManualPage";
import SearchPage from "./pages/SearchPage/SearchPage";
import axios from "axios";
import api from "./api/api";

const manualTypeLoader = async (payload) => {
  const manualType = payload.manualType;
  if (["kt", "g"].includes(manualType)) {
    return { manualType };
  } else {
    return redirect("/kt"); // 잘못된 manualType일 때 리다이렉트될 주소 필요
  }
};

const representManualLoader = async (params) => {
  const representManualUrl = await axios
    .get(`/api/${params.manualType}/${api.manual.represent.substring(5)}`)
    .then((res) => {
      return res.data.url.substring(1);
    })
    .catch((err) => {
      return "";
    });
  if (representManualUrl) {
    return redirect(representManualUrl);
  }
  return redirect("no-index");
};

function InnerApp() {
  const router = createBrowserRouter([
    {
      path: "/:manualType",
      loader: ({ params }) => manualTypeLoader(params),
      element: <MainPage />,
      children: [
        { path: ":name", element: <ManualPage /> },
        {
          path: "",
          loader: ({ params }) => representManualLoader(params),
        },
        {
          path: "*",
          loader: ({ params }) => representManualLoader(params),
        },
        {
          path: "searchpage/:value",
          element: <SearchPage />,
        },
      ],
    },
    {
      path: "/",
      loader: () => redirect("/kt"),
    },
  ]);

  return <RouterProvider router={router} />;
}

export default InnerApp;
